import Loadable from 'react-loadable';

const Loading = () => {
    return null;
};

const App = Loadable({
    loader: () => import('./flashVideo'),
    loading: Loading,
    delay: 500,
    timeout: 10000,
});

export default App;
